import { render, staticRenderFns } from "./Bier.vue?vue&type=template&id=040edd2c&scoped=true&"
import script from "./Bier.vue?vue&type=script&lang=js&"
export * from "./Bier.vue?vue&type=script&lang=js&"
import style0 from "./Bier.vue?vue&type=style&index=0&id=040edd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040edd2c",
  null
  
)

export default component.exports